import { ref } from "vue";
import { throttle } from "@/utils";
import { Message } from "element-ui";
import { useI18n } from "vue-i18n-composable";

export default function useVerificationCode(fn: Function) {
  const i18n = useI18n();

  const GET_CODE_TEXT = i18n.t("common.GetCode");
  const codeText = ref(GET_CODE_TEXT);

  const isGetting = ref(false);

  let timer: NodeJS.Timeout | null = null;

  const getVerificationCode = throttle(async (...params) => {
    if (isGetting.value) return;

    isGetting.value = true;
    let codeTime = 60;

    timer = setInterval(() => {
      if (codeTime === 0) {
        clearInterval(timer as NodeJS.Timeout);
        codeText.value = i18n.t("common.GetCode");
        isGetting.value = false;
      } else {
        codeText.value = `${i18n.t("common.Resend")}(${codeTime}s${i18n.t(
          "common.After"
        )})`;
        codeTime--;
      }
    }, 1000);

    const { success } = await fn(...params);

    if (success) {
      Message.success("验证码已发送");
    } else {
      Message.error("验证码发送失败");
    }
  }, 1000);

  const resetCode = () => {
    codeText.value = GET_CODE_TEXT;
    timer && clearInterval(timer);
  };

  return {
    codeText,
    getVerificationCode,
    resetCode,
    isGetting,
  };
}
